"use client";

import { useEffect } from "react";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import {
  ReactPlugin,
  AppInsightsContext,
} from "@microsoft/applicationinsights-react-js";

const reactPlugin = new ReactPlugin();
let appInsights = null;

if (
  typeof window !== "undefined" &&
  process.env.NEXT_PUBLIC_APPINSIGHTS_CONNECTION_STRING
) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString: process.env.NEXT_PUBLIC_APPINSIGHTS_CONNECTION_STRING,
      extensions: [reactPlugin],
      enableAutoRouteTracking: true, // Automatically tracks Next.js route transitions
    },
  });
  appInsights.loadAppInsights();
}

export default function AppInsightsProvider({ children }: any) {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      {children}
    </AppInsightsContext.Provider>
  );
}
